import { render, staticRenderFns } from "./PublicConvocatory.vue?vue&type=template&id=0fdf924e&scoped=true"
import script from "./PublicConvocatory.vue?vue&type=script&lang=js"
export * from "./PublicConvocatory.vue?vue&type=script&lang=js"
import style0 from "./PublicConvocatory.vue?vue&type=style&index=0&id=0fdf924e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf924e",
  null
  
)

export default component.exports